import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { IIcon } from '../../src';

@Injectable({
    providedIn: 'root',
})
export class AreaSvgRegistrationService {
    public static $name: string = 'areaSvgRegistrationService';

    private readonly dataDrivenIconFilenames = new Map<string, string>([
        [ 'monitoringBar', 'monitoring/svg/ic_local_bar_black_24px.svg' ],
        [ 'monitoringBuilding', 'monitoring/svg/ic_business_black_24px.svg' ],
        [ 'monitoringControls', 'monitoring/svg/ic_build_black_24px.svg' ],
        [ 'monitoringDining', 'monitoring/svg/ic_local_dining_black_24px.svg' ],
        [ 'monitoringDefault', 'monitoring/svg/ic_settings_black_24px.svg' ],
        [ 'monitoringEnergy', 'monitoring/svg/ic_power_settings_new_black_24px.svg' ],
        [ 'monitoringExhaust', 'monitoring/svg/ic_cloud_upload_black_24px.svg' ],
        [ 'monitoringExterior', 'monitoring/svg/ic_cloud_circle_black_24px.svg' ],
        [ 'monitoringFan', 'settings/svg/noun_Fan_100px.svg' ],
        [ 'monitoringHome', 'monitoring/svg/ic_home_black_24px.svg' ],
        [ 'monitoringKitchen', 'monitoring/svg/ic_kitchen_black_24px.svg' ],
        [ 'monitoringOutside', 'monitoring/svg/ic_nature_people_black_24px.svg' ],
        [ 'monitoringSupply', 'monitoring/svg/ic_cloud_download_black_24px.svg' ],
        [ 'monitoringThermostat', 'monitoring/svg/ic_iso_black_24px.svg' ],
        [ 'monitoringWater', 'monitoring/svg/ic_opacity_black_24px.svg' ],
        [ 'monitoringWeather', 'monitoring/svg/ic_wb_sunny_black_24px.svg' ],
    ]);

    private readonly constantIconFilenames = new Map<string, string>([
        [ 'settingsOccupancy', 'settings/svg/ic_wb_sunny_white_24px.svg' ],
        [ 'settingsLocation', 'settings/svg/ic_location_on_white_24px.svg' ],
        [ 'settingsLocationUser', 'settings/svg/ic_person_white_24px.svg' ],
        [ 'analyticsChart', 'analytics/svg/ic_pie_chart_outlined_black_24px.svg' ],
        [ 'behaviorFan', 'settings/svg/noun_Fan_100px.svg' ],
        [ 'behaviorFanOutlined', 'settings/svg/noun_Fan_outlined_100px.svg' ],
        [ 'behaviorHoodFanOutlined', 'settings/svg/noun_hood_fan_outlined_100px.svg' ],
        [ 'behaviorHoodLightOutlined', 'settings/svg/noun_hood_light_outlined_100px.svg' ],
        [ 'behaviorHood', 'settings/svg/noun_hood_small_100px.svg' ],
        [ 'behaviorHoodFan', 'settings/svg/noun_hood_Fan_100px.svg' ],
        [ 'behaviorRoomFan', 'settings/svg/noun_Fan_room_100px.svg' ],
        [ 'behaviorRoomFanOutlined', 'settings/svg/noun_Fan_room_outlined_100px.svg' ],
    ]);

    private readonly httpOptions = {
        headers: new HttpHeaders({
            'content-type': 'application/json'
        })
    };

    iconsLoaded = false;

    constructor(
        private readonly iconRegistry: MatIconRegistry,
        private readonly sanitizer: DomSanitizer,
        protected http: HttpClient,
    ) {
    }

    public registerMatIcons(url: string) {
        const iconsResponse =  this.http.get(url, this.httpOptions).pipe(take(1)) as any as Observable<IIcon[]>;
        iconsResponse.subscribe(icons => this.registerMatIconObjects(icons));
    }

    public registerMatIconObjects(icons: IIcon[]) {
        icons.forEach(icon => {
            if (this.dataDrivenIconFilenames.has(icon.name)) {
                this.registerIcon(icon.name, this.dataDrivenIconFilenames.get(icon.name));
            }
        });

        this.constantIconFilenames.forEach((value, key) => this.registerIcon(key, value));


        this.iconsLoaded = true;
    }

    private registerIcon(name: string, path: string) {
        const svg = require(`!!raw-loader!../../src/content/${path}`);
        this.iconRegistry.addSvgIconLiteral(
            name,
            this.sanitizer.bypassSecurityTrustHtml(svg.default));
    }
}
